import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    Input,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import { getBankFromSortCode } from '@netwealth/nw-utils';
import { IconComponent } from '../icon/icon.component';
import { Icons } from '../icon/constants/icons.constants';

@Component({
    selector: 'nw-bank-logo',
    templateUrl: './bank-logo.component.html',
    styleUrl: './bank-logo.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent]
})
export class BankLogoComponent implements OnChanges {
    @Input() sortCode!: string;

    @HostBinding('class.nw-bank-logo--default') isDefault: boolean = false;

    public icon!: Icons.Type;

    public ngOnChanges({ sortCode }: SimpleChanges): void {
        if (sortCode?.currentValue) {
            this.isDefault = false;

            const BANK: string = getBankFromSortCode(this.sortCode);
            switch (true) {
                case BANK.toLowerCase().includes('barclays'): {
                    this.icon = Icons.Banks.barclays;
                    return;
                }
                case BANK.toLowerCase().includes('halifax'): {
                    this.icon = Icons.Banks.lloyds;
                    return;
                }
                case BANK.toLowerCase().includes('hsbc'): {
                    this.icon = Icons.Banks.hsbc;
                    return;
                }
                case BANK === 'National Westminster Bank Plc' ||
                    BANK.toLowerCase().includes('netwest'): {
                    this.icon = Icons.Banks.national_westminster_bank;
                    return;
                }
                case BANK === 'The Royal Bank Of Scotland Plc' ||
                    BANK.toLowerCase().includes('rbs'): {
                    this.icon = Icons.Banks.royal_bank_of_scotland;
                    return;
                }
                case BANK === 'Bank Of Scotland Plc': {
                    this.icon = Icons.Banks.bank_of_scotland;
                    return;
                }
                case BANK.toLowerCase().includes('tsb'): {
                    this.icon = Icons.Banks.tsb;
                    return;
                }
                case BANK.toLowerCase().includes('santander'): {
                    this.icon = Icons.Banks.santander;
                    return;
                }
                case BANK === 'Bank of Ireland': {
                    this.icon = Icons.Banks.bank_of_ireland;
                    return;
                }
                case BANK === 'Standard Chartered Bank': {
                    this.icon = Icons.Banks.standard_chartered;
                    return;
                }
                case BANK === 'Monzo Bank Limited': {
                    this.icon = Icons.Banks.monzo;
                    return;
                }
                case BANK.toLowerCase().includes('lloyds'): {
                    this.icon = Icons.Banks.lloyds;
                    return;
                }
                case BANK.toLowerCase().includes('danske bank'): {
                    this.icon = Icons.Banks.danske_bank;
                    return;
                }
                case BANK === 'Mbna Limited': {
                    this.icon = Icons.Banks.mbna;
                    return;
                }
                case BANK === 'Icbc (London) Plc': {
                    this.icon = Icons.Banks.icbc;
                    return;
                }
                case BANK === 'Vanquis Bank Limited': {
                    this.icon = Icons.Banks.vanquis;
                    return;
                }
                case BANK === 'Jpmorgan Chase Bank, N.A.': {
                    this.icon = Icons.Banks.chase;
                    return;
                }
                case BANK === 'The Co-Operative Bank Plc': {
                    this.icon = Icons.Banks.cooperative_bank;
                    return;
                }
                case BANK === 'C Hoare & Co': {
                    this.icon = Icons.Banks.c_hoare_and_co;
                    return;
                }
                case BANK === 'Her MajestyS Revenue And Customs' ||
                    BANK === 'Government Banking': {
                    this.icon = Icons.Banks.hmrc;
                    return;
                }
                case BANK === 'Bank Of East Asia Ltd': {
                    this.icon = Icons.Banks.bank_of_east_asia;
                    return;
                }
            }

            this.isDefault = true;
            this.icon = Icons.Money.landmark;
        }
    }
}
